module.exports = __webpack_public_path__ + "img/iometeca.f7208f8f.png";